mutation UpdateProductPurchase($id: ID!, $input: UpdateProductPurchaseInput!) {
  updateProductPurchase(id: $id, input: $input) {
    id
    startAt
    expiredAt
  }
}
